import styles from './ResumeNav.module.scss';

interface Section {
  id: string;
  label: string;
}

interface Props {
  sections: Section[];
  activeSection: string;
  onNavigate: (id: string) => void;
}

export default function ResumeNav({ sections, activeSection, onNavigate }: Props) {
  return (
    <div className={styles.navWrapper}>
      <div className={styles.navInner}>
        {sections.map(s => (
          <button
            key={s.id}
            onClick={() => onNavigate(s.id)}
            className={`${styles.navButton} ${activeSection === s.id ? styles.active : ''}`}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}
